import React from 'react'
import { Button, Dropdown } from 'antd'
import { CodeOutlined, MessageOutlined, UpOutlined } from '@ant-design/icons'
import { actions } from '../../../../../store/reducers/assignment.reducer'
import assignmentSelectors from '../../../../../store/selectors/assignment.selectors'
import { useDispatch, useSelector } from 'react-redux'
import { LANGUAGES } from '../../../../../constants/languages'
import { useAssignmentAccess } from '../../access/Access'
import { ContentRules } from '../../access/access-rules/assignment-rules'

const CreatePatternDropdown = () => {
    const confirmChangesMode = useSelector(assignmentSelectors.confirmChangesMode)
    const showQueryEditor = useSelector(assignmentSelectors.showQueryEditor)
    const language = useSelector(assignmentSelectors.language)

    const dispatch = useDispatch()

    const handleQueryClick = () => dispatch(actions.setShowQueryEditor(!showQueryEditor))

    const handleSemanticClick = () => dispatch(actions.setShowSemanticPatternModal(true))

    const isNotTextAssignment = ![LANGUAGES.TEXT.value].includes(language)

    const createMenuItems = [
        ...(isNotTextAssignment
            ? [
                  {
                      key: 'query',
                      label: 'Query',
                      onClick: handleQueryClick,
                      icon: <CodeOutlined />,
                  },
              ]
            : []),
        {
            key: 'semantic',
            label: 'Semantic',
            disabled: confirmChangesMode,
            title: confirmChangesMode ? 'Save or revert current changes before creating new pattern' : null,
            onClick: handleSemanticClick,
            icon: <MessageOutlined />,
        },
    ]

    const { hasAccess: hasEditingPermission } = useAssignmentAccess(ContentRules.EDIT_GRADINGS)

    return (
        <>
            <Dropdown
                menu={{ items: createMenuItems, triggerSubMenuAction: 'click' }}
                autoFocus
                trigger={['click']}
                disabled={!hasEditingPermission}
                destroyPopupOnHide
                // getPopupContainer={() => document.getElementById('site-layout-header')}
            >
                <Button data-test="create-pattern-button">
                    Create pattern <UpOutlined aria-hidden />
                </Button>
            </Dropdown>
        </>
    )
}

export default CreatePatternDropdown
